import { forwardRef, type CSSProperties } from 'react'

import { ChevronRightIcon, LogoutIcon, PrivacyTipIcon, ProfileIcon } from '@/components/core/Icon/icons'
import { SIDEBAR_TEST_IDS } from '@/constants/testIds'

import { MenuItem } from './MenuItem'

interface MainPanelProps {
  userEmail: string
  subOpen: boolean
  style?: CSSProperties
  privacyRowRef: (node: HTMLButtonElement | HTMLAnchorElement | null) => void
  onPrivacyHoverEnter: () => void
  onPrivacyHoverLeave: () => void
  onPrivacyClick: () => void
  onMyAccount?: () => void
  onLogout: () => void
}

export const MainPanel = forwardRef<HTMLDivElement, MainPanelProps>(function MainPanel(
  {
    userEmail,
    subOpen,
    style,
    privacyRowRef,
    onPrivacyHoverEnter,
    onPrivacyHoverLeave,
    onPrivacyClick,
    onMyAccount,
    onLogout,
  },
  ref,
) {
  return (
    <div ref={ref} className="sidebar-profile-menu__menu" style={style} role="menu" aria-label="Profile">
      <div className="sidebar-profile-menu__email-header" title={userEmail}>
        {userEmail}
      </div>
      {typeof onMyAccount !== 'undefined' && (
        <MenuItem label="My account" leadingIcon={<ProfileIcon />} onClick={onMyAccount} />
      )}
      <MenuItem
        ref={privacyRowRef}
        label="Privacy & Terms"
        leadingIcon={<PrivacyTipIcon />}
        trailingIcon={<ChevronRightIcon size={20} />}
        onClick={onPrivacyClick}
        onMouseEnter={onPrivacyHoverEnter}
        onMouseLeave={onPrivacyHoverLeave}
        hoverActive={subOpen}
        borderBottom
        data-testid={SIDEBAR_TEST_IDS.PROFILE_MENU_PRIVACY_TERMS}
      />
      <MenuItem
        label="Logout"
        leadingIcon={<LogoutIcon />}
        onClick={onLogout}
        data-testid={SIDEBAR_TEST_IDS.PROFILE_MENU_LOGOUT}
      />
    </div>
  )
})
